export default __webpack_public_path__ + "static/media/vanadium.25343687.jpg";